import $http from "axios";
import LZString from "lz-string";
import $qs from "querystring";

const rlServerURL = window.rlServerURL;

const ApiDataService = {
    get: function (queryParameter, Url) {
        Url = rlServerURL.API + Url;
        return $http
            .get(Url, { params: queryParameter, withCredentials: true, headers: { "Compress-Output": true, "Content-Type": "application/x-www-form-urlencoded" } })
            .then(response => {
                response.data.result = parseAndDecodeResult(response.data.result);
                return response;
            })
            .catch(error => {
                console.log(error);
                return error;
            });
    },
    post: function (queryParameter, Url) {
        Url = rlServerURL.API + Url;
        return $http
            .post(Url, queryParameter, { withCredentials: true,})
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response;
            });
    }
};

const parseAndDecodeResult = function (returnItem) {
    let strReturnJson = JSON.parse(LZString.decompressFromUTF16(returnItem));
    return strReturnJson;
};

export default {
    parseAndDecodeResult,
    ApiDataService
};



// WEBPACK FOOTER //
// ./src/apiservice.js